// TODO: fix ts-check remove eslint-disable
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useRef, useEffect, useContext, FC } from 'react';
import { axisLeft, axisBottom, AxisDomain } from 'd3-axis';
import { select, Selection } from 'd3-selection';
import { timeDay } from 'd3-time';
import { timeFormat } from 'd3-time-format';

import { FONT } from 'src/constants/font';
import formatDate from 'src/modules/formatDate';

import ChartContext from 'src/components/LineChart/ChartContext';

import styles from 'src/components/LineChart/line-chart.less';

const d3 = { select, axisBottom, axisLeft, timeFormat, timeDay };

const D3_TICK_SELECTOR = '.tick line';
const GRID_OPACITY = 0.1;

export enum AxisPosition {
    Bottom = 'bottom',
    Left = 'left',
}

export enum AxisName {
    X = 'x',
    Y = 'y',
}

const hideLineAxis = (axis: Selection<SVGGElement, unknown, null, undefined>) => {
    axis.call((g) => {
        g.select('.domain').remove();
        g.selectAll('line').remove();
    });
};

const defaultLabelFormat = (value: AxisDomain) => {
    if (typeof value === 'number') {
        return String(value);
    } else if (value instanceof Date) {
        return formatDate(value, 'dd.MM');
    }
    return '';
};

interface AxisProps {
    axisName: AxisName;
    position: AxisPosition;
    chartIndex?: number;
    showLine?: boolean;
    showAdditionalLines?: boolean;
    labelFormat?: (value: AxisDomain) => string;
    ticksCount?: number;
}

const Axis: FC<AxisProps> = ({
    chartIndex = 0,
    axisName,
    position,
    showLine = true,
    showAdditionalLines,
    labelFormat = defaultLabelFormat,
    ticksCount,
}) => {
    const wrapperRef = useRef<SVGGElement>(null);
    const { chartData, width, height } = useContext(ChartContext);

    const lineData = chartData[chartIndex];
    const data = axisName === AxisName.X ? lineData.xAxis : lineData.yAxis;
    const createAxisFunction = position === AxisPosition.Bottom ? d3.axisBottom : d3.axisLeft;

    useEffect(() => {
        const wrapper = d3.select(wrapperRef.current);

        // d3 не умеет нормально отображать нужное количество рисок для оси c датами
        // поэтому ему вместо количества этих рисок надо передать функцию, которая вернет список дат,
        // которые хотим вывести на оси
        let getTicksForPeriod;
        if (ticksCount && axisName === AxisName.X) {
            const tickPeriod = Math.floor(lineData.data.length / ticksCount) + 1;
            const firstDay = lineData.data[0].date;
            getTicksForPeriod = d3.timeDay.filter((day) => d3.timeDay.count(firstDay, day) % tickPeriod === 0);
        }

        // FIXME: fix ts-check remove any
        const axis = wrapper
            .append('g')
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            .call((createAxisFunction(data) as any).ticks(getTicksForPeriod || ticksCount).tickFormat(labelFormat));

        if (position === AxisPosition.Bottom) {
            axis.attr('transform', `translate(0,${height})`);
            if (showAdditionalLines) {
                axis.call((g) =>
                    g.selectAll(D3_TICK_SELECTOR).clone().attr('stroke-opacity', GRID_OPACITY).attr('y2', -height)
                );
            }
        }
        if (position === AxisPosition.Left) {
            if (showAdditionalLines) {
                axis.call((g) =>
                    g.selectAll(D3_TICK_SELECTOR).clone().attr('stroke-opacity', GRID_OPACITY).attr('x2', width)
                );
            }
        }

        if (!showLine) {
            hideLineAxis(axis);
        }

        wrapper.selectAll('text').attr('font-family', FONT);

        return () => {
            axis.remove();
        };
    }, [
        axisName,
        createAxisFunction,
        data,
        height,
        labelFormat,
        lineData.data,
        position,
        showAdditionalLines,
        showLine,
        ticksCount,
        width,
    ]);

    return <g ref={wrapperRef} className={styles.lineChartTicks} />;
};

export default Axis;
